import { PolymerElement, html } from "@polymer/polymer/polymer-element.js";
import "@polymer/polymer/lib/elements/dom-repeat.js";
import { _checkMenuOptionsActive } from "../../../../utils/ecourse";
import Alodokter from "../../../../utils/Alodokter";

import arrow from "images/icons/icon_arrow_right_blue.svg";

import "./EcourseMenuOption.style";
import GeneralAnalytics from "../../../../analytics/GeneralAnalytics";

class EcourseMenuOption extends PolymerElement {
  static get template() {
    return html `
      <style include="webinar-menu-option-style"></style>
      <div class="container">
        <dom-repeat items="{{menuOptionList}}" as="optionItem">
          <template>
            <div class="item-container" >
              <img src="[[iconArrowRightBlue]]" alt="alomedika" />
              <a href="{{optionItem.path}}" on-click="sendEventGaOptionPageView" class$="[[_checkMenuOptionsActive(optionItem.path)]]">{{optionItem.option_value}}</a>
            </div>
          </template>
        </dom-repeat>
      </div>
    `;
  }

  static get properties() {
    return {
      iconArrowRightBlue: {
        type: String,
        value: arrow,
      },

      menuOptionList: {
        type: Array,
        value() {
          return [{
              option_value: "Cari E-Course",
              path: "/ecourse",
            },
            {
              option_value: "Aktivitas E-Course",
              path: "/ecourse/activity",
            },
            {
              option_value: "FAQ",
              path: "/ecourse/faq",
            },
          ];
        },
      },
      _checkMenuOptionsActive: {
        type: Function,
        value: () => _checkMenuOptionsActive,
      },
      userUid: {
        type: String,
      },
      isLogin: {
        type: Number,
      },
    };
  }

  sendEventGaOptionPageView(e) {
    let path = e.target.pathname;
    if (path == "/ecourse") {
      this.sendEventGaSearchEcourse("e-course landing page", path, "ecourse_search_ecourse");
    } else if (path == "/ecourse/activity") {
      this.sendEventGaMyActivity("e-course my activity page", "ecourse_activity_clicked");
    } else if (path == "/ecourse/faq") {
      GeneralAnalytics.faq("ecourse", "landing")
    }
  }

  sendEventGaSearchEcourse(category, path, eventActionLabel) {
    const userUid = this.getTrackingUserUid();
    const sourceUrl = window.location.origin + path;
    const eventLabel = `${userUid}source url: ${sourceUrl} | device_category: desktop`;
    Alodokter.sendEventGA(category, eventActionLabel, eventLabel);
  }

  sendEventGaMyActivity(category, eventActionLabel) {
    const userUid = this.getTrackingUserUid();
    const eventLabel = `${userUid}device_category: desktop`;
    Alodokter.sendEventGA(category, eventActionLabel, eventLabel);
  }

  getTrackingUserUid() {
    let userUidStr = ""
    if (this.userUid) {
      userUidStr = `user_uid: ${this.userUid} | `;
    }
    return userUidStr;
  }
}
customElements.define("ecourse-menu-option", EcourseMenuOption);